"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADMIN_SUBMISSION_SYNC_COVER_MUTATION = exports.AdminSubmissionSyncCoverInputGql = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.AdminSubmissionSyncCoverInputGql = (0, graphql_tag_1.default) `
  input AdminSubmissionSyncCoverInput {
    id: String!
  }
`;
exports.ADMIN_SUBMISSION_SYNC_COVER_MUTATION = (0, graphql_tag_1.default) `
  mutation synchroniseCover($input: AdminSubmissionSyncCoverInput!) {
    adminSubmissionSyncCover(input: $input) {
      id
    }
  }
`;
